// polyfill for closest and matches from https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
export function closestElementPolyfill() {
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  }

  if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      let el = this;

      do {
        if (el.matches(s)) return el;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }
}

let arePolyfillsLoaded = false;

async function injectPolyfills() {
  if (!arePolyfillsLoaded) {
    const polyfills = [];
    let promises;

    if (window && !window.IntersectionObserver) {
      polyfills.push(import(/* webpackChunkName: "IntersectionObserverPolyfill" */ 'intersection-observer'));
    }

    if (typeof URL !== 'function') {
      polyfills.push(import(/* webpackChunkName: "url-polyfill" */ 'url-polyfill'));
    }

    try {
      promises = await Promise.all(polyfills);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Failed to load polyfills');
    }

    arePolyfillsLoaded = true;
    return promises;
  }
}

export function onPolyfillsLoaded(callback) {
  return injectPolyfills()
    .then(callback)
    .catch(error => {
      console.log(error); // eslint-disable-line no-console
    });
}
